/**
 * WoxomQuote — Entry point
 *
 * This file imports all modules and exposes them to the global scope
 * for use by the existing vanilla JS app. New feature modules are
 * added here as ES module imports.
 *
 * data.js, iron-health-data.js, api.js, and cms-api.js remain as
 * separate script tags since they use window globals.
 */

// Feature modules (new functionality)
import { QuoteActions } from './modules/quote-actions.js';
import { QuotesDrawer } from './modules/quotes-drawer.js';
import { AgentIdentity } from './modules/agent-identity.js';
import { Onboarding } from './modules/onboarding.js';
import { CrossSell } from './modules/cross-sell.js';
import { RateChecker } from './modules/rate-checker.js';
import { HealthQuestionnaire } from './modules/health-questionnaire.js';
import { PlanScorer } from './modules/plan-scorer.js';
import { groupPlanVariants, deriveVariantAxes, findVariant, findVariantByAxes, groupKeyFor, availableLevelValues, normalizeGroupType, optionalRiders, activeRidersFor, effectivePremium, defaultActiveRiders } from './modules/plan-grouping.js';
import { isAvailableInState, filterByState } from './modules/state-filter.js';
import { Cart } from './modules/cart.js';
import { Format } from './modules/format.js';
import { PlanClassify } from './modules/plan-classify.js';
import { PlanFilter } from './modules/plan-filter.js';
import { CartConflict } from './modules/cart-conflict.js';
import { DateField } from './modules/date-field.js';
import { AuthGate } from './modules/auth-gate.js';
import { Feedback } from './modules/feedback.js';
import { Compare } from './modules/compare.js';
import { Handoff } from './modules/handoff.js';
import { AdvisorFacts } from './modules/advisor-facts.js';
import { AdvisorRules } from './modules/advisor-rules.js';
import { AdvisorFit } from './modules/advisor-fit.js';
import { AdvisorNormalize } from './modules/advisor-normalize.js';
import { AdvisorEngine } from './modules/advisor-engine.js';
import { AdvisorUI } from './modules/advisor-ui.js';
import { AdvisorAdmin } from './modules/advisor-admin.js';

// Expose modules globally for use by existing code and HTML event handlers
window.WoxomQuote = {
  QuoteActions,
  QuotesDrawer,
  AgentIdentity,
  Onboarding,
  CrossSell,
  RateChecker,
  HealthQuestionnaire,
  PlanScorer,
  PlanGrouping: { groupPlanVariants, deriveVariantAxes, findVariant, findVariantByAxes, groupKeyFor, availableLevelValues, normalizeGroupType, optionalRiders, activeRidersFor, effectivePremium, defaultActiveRiders },
  StateFilter: { isAvailableInState, filterByState },
  Cart,
  Format,
  PlanClassify,
  PlanFilter,
  CartConflict,
  DateField,
  AuthGate,
  Feedback,
  Compare,
  Handoff,
  AdvisorFacts,
  AdvisorRules,
  AdvisorFit,
  AdvisorNormalize,
  AdvisorEngine,
  AdvisorUI,
  AdvisorAdmin,
};
